import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { capitalize } from "@mui/material";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

// ✅ Helper to truncate HTML safely
const truncateHTML = (html = "", limit = 95) => {
  if (!html) return { excerpt: "", isLong: false };
  const div = document.createElement("div");
  div.innerHTML = html;
  const text = div.textContent || div.innerText || "";
  if (text.length <= limit) return { excerpt: html, isLong: false };
  const truncatedText = text.slice(0, limit).trimEnd();
  return { excerpt: truncatedText + "…", isLong: true };
};

function GridMinimalReviews() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [reviewsData, setReviewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    getReviewsData();
  }, []);

  const getReviewsData = async () => {
    try {
      setIsLoading(true);
      const response = await SendPostRequest("reviews");
      setReviewsData(response?.data || []);
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviewsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  return (
    <>
      {isLoading ? (
        <div className="d-flex justify-content-center">
          <Spinner />
        </div>
      ) : reviewsData?.length > 0 ? (
        <div className="container">
          <div className="row mb-4 mt-5">
            <div className="offset-md-2 col-md-8">
              <div className="title-wrap text-center">
                <div className="section-title margin-bottom-60">
                  <h2 className="section-title mb-0 text-uppercase">
                    Patient <span className="theme-color">Reviews</span>
                  </h2>
                  <span className="section-border-bottom center"></span>
                </div>
              </div>
            </div>

            <div className="col-md-12 testimonails p-0" data-animation="fadeInRight">
              <OwlCarousel
                className="owl-carousel testimonial-style-6 dark-switch"
                 style={{ padding: isMobile ? "10px" : "0px" }}
                loop={true}
                nav={false}
                dots={false}
                autoplay={true}
                autoplayHoverPause
                autoplayTimeout={5000}
                smartSpeed={250}
                margin={30}
                items={3}
                responsive={{
                  0: { items: 1 },
                  768: { items: 2 },
                  1024: { items: 3 },
                }}
              >
                {reviewsData.map((data, index) => {
                  const { excerpt, isLong } = truncateHTML(data?.detail, 95);

                  return (
                    <div
                      key={index}
                      className="item animated fadeInRight visible"
                      style={{ width: isMobile ? "100%" : "95%" }}
                    >
                      <div className="quote grid-minal-review-border" style={{ height: "205px" }}>
                        <blockquote className="small-text mb-0">
                          <p>
                            <span
                              dangerouslySetInnerHTML={{ __html: excerpt }}
                            />
                            {isLong && (
                              <>
                                {" "}
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleShowMore(data);
                                  }}
                                  className="fw-bold"
                                >
                                  See More
                                </Link>
                              </>
                            )}
                          </p>
                        </blockquote>
                      </div>

                      <div className="client-details text-center">
                        <div className="client-image margin-bottom-10">
                          <img
                            className="img-circle b-radius-50"
                            src={data?.profile_image || "/assets/img/no-image.png"}
                            style={{ width: "65px", height: "65px" }}
                            alt={data?.full_name || "reviewer"}
                          />
                        </div>
                        <div className="client-details">
                          <strong className="theme-color mb-2">{data?.full_name}</strong>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </OwlCarousel>
            </div>
          </div>
        </div>
      ) : (
        <h4 className="text-center my-5">No Reviews Available</h4>
      )}

      {/* Modal for full review */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedReview && (
            <div
              dangerouslySetInnerHTML={{ __html: selectedReview?.detail || "" }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-default" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default GridMinimalReviews;
